import Button from "@mui/material/Button";

import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const StyledButton = styled(Button)(() => ({
  backgroundColor: `#2380C3`,
  borderRadius: "10px",
  width: "100%",
  height: "auto",
  fontSize: "14px",
  fontWeight: 400,
  fontFamily: "Montserrat, sans-serif",
  textTransform: "initial",
  "&:hover": {
    backgroundColor: `#2380C3`,
  },
  // "@media (max-width:660px)": {
  //   width: "160px",
  // },
}));

export default function ButtonLight({ text, route, funcao, disabled }) {
  const navigate = useNavigate();

  return (
    <StyledButton
      disabled={disabled}
      variant="contained"
      onClick={() => {
        if (funcao) {
          funcao();
        } else {
          navigate(`${route}`);
        }
      }}
    >
      {text}
    </StyledButton>
  );
}
